<template>
    <div>
        <action-bar class="action-bar">
            <template v-slot:left>
                <h3 class="pb-3">Media</h3>
            </template>
        </action-bar>
        <vx-input
            label="Content Number"
            name="Content Number"
            :rules="['required']"
            type="number"
            v-model="tempContent.contentNumber"
            class="w-full"
            placeholder="Enter Content Number"
        />

        <vx-textarea
            label="Content Description"
            name="Content Description"
            :rules="['required']"
            v-model="tempContent.description"
            rows="3"
            class="w-full mt-3"
        ></vx-textarea>

        <vx-input
            label="Content Duration (minutes)"
            name="Content Duration"
            :rules="[
                'required',
                (v) =>
                    (v && v > 0 && /^[0-9]{1,10}$/.test(v)) ||
                    'Must be a whole number greater than 0'
            ]"
            type="number"
            v-model="tempContent.durationMinutes"
            class="w-full"
            placeholder="Enter Content Duration"
        />

        <vx-select
            label="Author Name"
            name="Author Name"
            :rules="['required']"
            placeholder="Choose Author"
            class="w-full"
            v-model="tempContent.author"
            :options="authors"
            idKey="id"
            :textKey="(a) => a.firstName + ' ' + a.lastName"
        >
        </vx-select>

        <vx-resource-set
            :resources="menuImage"
            allow-create
            allow-delete
            :limit="1"
            read-only
            justify="center"
            text="Upload Session Menu Image"
            class="mr-2 imageUploaderText"
            @uploaded="setMenuImage"
        >
        </vx-resource-set>

        <vx-select
            label="Media Type"
            name="Media Type"
            :rules="['required']"
            placeholder="Choose Audio or Vimeo"
            class="w-full"
            v-model="tempContent.mediaType"
            :options="mediaTypes"
            valueKey="id"
            textKey="type"
        >
        </vx-select>

        <vx-resource-set
            v-if="tempContent.mediaType == 1"
            :resources="audioFile"
            allow-create
            allow-delete
            :limit="1"
            read-only
            justify="center"
            text="Upload Audio File"
            class="mr-2 imageUploaderText"
            @uploaded="setAudioFile"
        >
        </vx-resource-set>

        <vx-input
            v-if="tempContent.mediaType == 2"
            label="Video Link"
            name="Video Link"
            :rules="['required']"
            v-model="tempContent.url"
            type="text"
            class="w-full"
            placeholder="Enter Video Link / URL"
        />

        <vx-calendar-input
            label="Available From"
            name="Available From"
            class="w-full"
            v-model="tempContent.availableFrom"
        ></vx-calendar-input>

        <vx-calendar-input
            label="Available To"
            name="Available To"
            :rules="[validateAvailableTo]"
            class="w-full"
            v-model="tempContent.availableTo"
        ></vx-calendar-input>

        <div class="flex justify-center mt-10 relative">
            <vs-button
                @click="saveContent"
                color="success"
                type="gradient"
                icon="save"
                :disabled="disableSave && !tempContent.contentId"
            >
                Save Media
            </vs-button>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'

export default {
    name: 'media-card',
    components: {
        ActionBar
    },
    props: {
        mediaPacket: {
            type: Object
        },
        disableSave: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            authors: [],
            mediaTypes: [
                { id: 1, type: 'Audio' },
                { id: 2, type: 'Vimeo' }
            ],
            tempContent: {
                author: null,
                contentNumber: null,
                description: '',
                durationMinutes: null,
                mediaType: 1,
                audioFile: [],
                url: null,
                menuImage: [],
                availableFrom: new Date(),
                availableTo: null
            },

            menuImage: [],
            audioFile: []
        }
    },
    watch: {
        mediaPacket: {
            handler: async function (val) {
                if (val) {
                    this.tempContent = this.deepCopy(val)
                    if (this.tempContent.menuImage) {
                        this.setMenuImage(this.tempContent.menuImage)
                    }
                }
            }
        }
    },
    computed: {},
    methods: {
        async saveContent() {
            this.loading = true
            if (await this.validate()) {
                try {
                    var response

                    if (this.tempContent.contentId) {
                        //update
                        response = await this.$api.content.updateContent(this.tempContent)
                        await this.saveMenuImage(this.tempContent.contentId)
                        await this.saveAudioFile(this.tempContent.contentId)
                        this.notifySuccess(
                            'Updated successfully',
                            'Media Updated successfully.',
                            5000
                        )
                        this.$emit('mediaEdited', this.tempContent)
                    } else {
                        //create
                        response = await this.$api.content.createContent(this.tempContent)
                        this.tempContent.contentId = response.id

                        await this.saveMenuImage(this.tempContent.contentId)
                        await this.saveAudioFile(this.tempContent.contentId)
                        this.notifySuccess(
                            'Created successfully',
                            'Media created successfully.',
                            5000
                        )
                        this.$emit('mediaAdded', this.tempContent)
                    }

                    this.tempContent = {
                        author: null,
                        description: '',
                        contentNumber: null,
                        durationMinutes: null,
                        mediaType: 1,
                        url: null
                    }
                    this.audioFile = []
                    this.menuImage = []
                } catch (err) {
                    console.error(err)

                    this.notifyError('Error', `Error message: ${err}`, 5000)
                } finally {
                    this.loading = false
                }
            }
            this.loading = false
        },
        setMenuImage(newImage) {
            this.$set(this.menuImage, 0, newImage)
        },
        async saveMenuImage(id) {
            if (this.menuImage.any() && this.menuImage[0].file) {
                await this.$api.content.updateMenuImage(id, this.menuImage[0])
            }
        },
        setAudioFile(newAudioFile) {
            this.$set(this.audioFile, 0, newAudioFile)
        },
        async saveAudioFile(id) {
            if (this.audioFile.any() && this.audioFile[0].file) {
                await this.$api.content.updateAudioFile(
                    id,
                    this.tempContent.durationMinutes,
                    this.audioFile[0]
                )
            }
        },
        validateAvailableTo() {
            if (!this.tempContent.availableTo || !this.tempContent.availableFrom) {
                return true
            }

            if (this.tempContent.availableTo > this.tempContent.availableFrom) {
                return true
            }

            return 'Please enter a date after the "Available From" date'
        }
    },
    async mounted() {
        var response = await this.$api.author.fetchAuthors({ pageSize: 500 })
        this.authors = response.data
    }
}
</script>

<style lang="scss" scoped>
.imageUploaderText {
    font-size: 0.85rem;
}
</style>
